import { render, staticRenderFns } from "./TrendingCarouselWidget.vue?vue&type=template&id=26e7f678&scoped=true"
import script from "./TrendingCarouselWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrendingCarouselWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TrendingCarouselWidget.vue?vue&type=style&index=0&id=26e7f678&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e7f678",
  null
  
)

export default component.exports